import React from 'react';

import DownloadApp from '../components/DownloadApp/DownloadApp';
import Helmet from '../components/common/Helmet';

function AppHomeContainer() {
  return (
    <div className="AppHome">
      <Helmet
        titleTranslationKey="AppHomeContainerTitle"
        descriptionTranslationKey="AppHomeContainerhelmetDescription"
      />
      <DownloadApp />
    </div>
  );
}

export default AppHomeContainer;
